import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { useVirtualToggle } from '@sorare/core/src/hooks/useVirtualToggle';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { VirtualToggleFilter } from '@sorare/core/src/lib/filters';

type Props = {
  filter: VirtualToggleFilter;
  cleanableFilters?: VirtualToggleFilter[];
  needsLogin?: boolean;
  onChange?: (b: boolean) => void;
};
export const useVirtualFilterSegment = ({
  filter,
  cleanableFilters = [],
  needsLogin,
  onChange,
}: Props) => {
  const track = useEvents();
  const setVirtualToggle = useVirtualToggleManager();
  const { currentRefinement } = useVirtualToggle<boolean>({
    name: filter.name,
  });

  const handleChange = () => {
    const newValue = !currentRefinement;
    setVirtualToggle({
      ...cleanableFilters.reduce(
        (acc, curr) => ({ ...acc, [curr.name]: false }),
        {}
      ),
      [filter.name]: newValue,
    });
    track('Use Market Filter', {
      filterName: filter.trackingName,
      filterValue: newValue.toString(),
    });
    onChange?.(newValue);
  };

  const loggedHandleChange = useLoggedCallback(handleChange);
  const checked = !!currentRefinement;

  return {
    checked,
    onChange: needsLogin ? loggedHandleChange : handleChange,
  };
};
